module.exports = __webpack_public_path__ + "img/yellow-arrows.c9d182bc.svg";